import type { Policy } from '@/data/subsidy/policies/interfaces';

export type ParsedPolicyLimits = {
  percentageLimit: number;
  amountLimitPerPurchase: number;
  cycleBalance: number;
  hasPercentage: boolean;
  hasPurchaseCap: boolean;
  hasCycleBalance: boolean;
};

export const parsePolicyLimits = (
  limits: Policy['limits']
): ParsedPolicyLimits => {
  const percentageLimit = parseFloat(
    limits.percentage_limit_per_purchase ?? '0'
  );
  const amountLimitPerPurchase = parseFloat(
    limits.amount_limit_per_purchase_cents ?? '0'
  );
  const cycleBalance = parseFloat(limits.amount_limit_per_cycle_cents ?? '0');

  return {
    percentageLimit,
    amountLimitPerPurchase,
    cycleBalance,
    hasPercentage: percentageLimit > 0,
    hasPurchaseCap: amountLimitPerPurchase > 0,
    hasCycleBalance: cycleBalance > 0,
  };
};
